import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { Lock } from 'lucide-react';
import LogoWhite from '../../assets/images/logos/white-bg-logo-hiacuity.png';
import { Button } from '../../ui';
import { TextInput } from '../../ui/input/text_input/text_input';
import { useAdminLogin } from './hooks';
import { AuthenticationUiLayout } from '../login_register/AuthenticationUILayout';

export const AdminLogin: React.FC = () => {
  const login = useAdminLogin();

  return (
    <Box>
      <AuthenticationUiLayout
        leftContent={
          <Stack alignItems="center" spacing={3}>
            <Box
              sx={{
                width: 80,
                height: 80,
                borderRadius: 4,
                bgcolor: 'rgba(255, 255, 255, 0.2)',
                backdropFilter: 'blur(12px)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: '1px solid rgba(255, 255, 255, 0.3)',
                boxShadow: 3,
              }}
            >
              <Lock size={40} color="#ffffff" />
            </Box>
            <Stack spacing={1} textAlign="center">
              <Typography variant="h3" sx={{ fontWeight: 700, letterSpacing: '-0.02em', color: '#ffffff' }}>
                Admin Login
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(236, 253, 245, 0.8)', maxWidth: 320, mx: 'auto' }}>
                Empowering your talent acquisition with intelligent assessments.
              </Typography>
            </Stack>
          </Stack>
        }
      >
        <Stack spacing={3} alignItems="flex-start" sx={{ width: '100%', pt: 2 }}>
          <Box component="img" src={LogoWhite} alt="Logo" sx={{ width: 200 }} />
          <Typography variant="h5" sx={{ fontWeight: 600, color: 'text.primary', letterSpacing: '-0.01em' }}>
            Admin Login
          </Typography>
        </Stack>
        <Box
          component="form"
          sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 5, pb: 5 }}
          onSubmit={(e) => void login.handleSubmit(e)}
          data-testid="login-form"
        >
          <TextInput
            type="text"
            label="Username"
            name="email"
            value={login.username}
            onChange={login.handleUsernameChange}
            required
          />
          <TextInput
            type="password"
            label="Password"
            name="password"
            value={login.password}
            onChange={login.handlePasswordChange}
            required
          />
          <Button type="submit" label="Login" variant="primary" />
        </Box>
      </AuthenticationUiLayout>
    </Box>
  );
};

export default AdminLogin;
